export const ip = "https://trailsync.herokuapp.com";
// export const ip = "http://localhost:3000";
